(function () {
  'use strict';

  var SELECTORS = {
    container: '[data-collection-infinite-scroll]',
    productList: '[data-collection-products]',
    loading: '[data-collection-infinite-loading]',
    end: '[data-collection-infinite-end]',
    sentinel: '.collection-infinite-scroll__sentinel'
  };

  function CollectionInfiniteScroll(container) {
    this.container = container;
    this.nextUrl = container.dataset.nextUrl || '';
    this.loading = false;
    this.observer = null;
    this.productList = document.querySelector(SELECTORS.productList);
    this.loadingEl = container.querySelector(SELECTORS.loading);
    this.endEl = container.querySelector(SELECTORS.end);
    this.sentinel = container.querySelector(SELECTORS.sentinel);

    if (!this.nextUrl || !this.productList || !this.sentinel) return;

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      rootMargin: '300px 0px'
    });
    this.observer.observe(this.sentinel);
  }

  CollectionInfiniteScroll.prototype.onIntersect = function (entries) {
    if (entries[0].isIntersecting) {
      this.loadMore();
    }
  };

  CollectionInfiniteScroll.prototype.loadMore = function () {
    if (this.loading || !this.nextUrl) return;

    this.loading = true;
    this.setLoadingVisible(true);

    fetch(this.nextUrl)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to load collection page');
        }
        return response.text();
      })
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this));
  };

  CollectionInfiniteScroll.prototype.handleResponse = function (html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newList = doc.querySelector(SELECTORS.productList);
    var newInfinite = doc.querySelector(SELECTORS.container);

    if (newList) {
      Array.prototype.forEach.call(newList.children, function (item) {
        this.productList.appendChild(document.importNode(item, true));
      }.bind(this));
    }

    this.nextUrl = newInfinite && newInfinite.dataset.nextUrl ? newInfinite.dataset.nextUrl : '';
    this.container.dataset.nextUrl = this.nextUrl;

    if (typeof AOS !== 'undefined') {
      AOS.refresh();
    }

    if (window.lazySizes && window.lazySizes.loader) {
      window.lazySizes.loader.checkElems();
    }

    this.loading = false;
    this.setLoadingVisible(false);

    if (!this.nextUrl) {
      this.observer.disconnect();
      this.setEndVisible(true);
    }
  };

  CollectionInfiniteScroll.prototype.handleError = function () {
    this.loading = false;
    this.setLoadingVisible(false);
    this.observer.disconnect();
  };

  CollectionInfiniteScroll.prototype.setLoadingVisible = function (visible) {
    if (!this.loadingEl) return;
    this.loadingEl.classList.toggle('hide', !visible);
  };

  CollectionInfiniteScroll.prototype.setEndVisible = function (visible) {
    if (!this.endEl) return;
    this.endEl.classList.toggle('hide', !visible);
  };

  function init() {
    document.querySelectorAll(SELECTORS.container).forEach(function (container) {
      if (container.dataset.initialized === 'true') return;
      container.dataset.initialized = 'true';
      new CollectionInfiniteScroll(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
